export default __webpack_public_path__ + "static/media/SphereCoreEntropy.bddb8f15.webp";